<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>赛项评审管理</el-breadcrumb-item>
      <el-breadcrumb-item>设置评审标准</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="4" style="width:360px !important;margin-right: 20px;">
          <el-select v-model="queryInfo.MatchID" placeholder="请选择赛项名称" clearable
            @change="selectGettrack(queryInfo.MatchID, 0)" style="width:360px !important;">
            <el-option v-for="item in matchNameoptions" :key="item.MatchID" :label="item.MatchName"
              :value="item.MatchID">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" style="margin-right:30px;">
          <el-select v-model="queryInfo.TrackID" placeholder="请选择赛道" clearable style="width: 370px !important;">
            <el-option v-for="item in trackNameoptions" :key="item.TrackID" :label="item.TrackName"
              :value="item.TrackID">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-button icon="el-icon-search" type="primary" @click="getStandardList(1)">搜索</el-button>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" @click="showAddCreate">添加评分标准</el-button>
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column prop="SortIndex" label="排序" width="55">
          <template slot-scope="scope">
            <div>
              <el-input size="mini" v-model="scope.row.SortIndex" @change="setSortIndex(scope.row)">
              </el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="MatchName" label="赛事名称" width="280">
        </el-table-column>
        <el-table-column prop="TrackName" label="赛道名称"> </el-table-column>
        <el-table-column prop="StandardName" label="标准名称">
        </el-table-column>
        <el-table-column prop="StandardContent" label="标准内容" width="380">
        </el-table-column>
        <el-table-column prop="Score" label="分数" width="50"> </el-table-column>
        <el-table-column prop="AddTime" label="添加日期" :formatter="dataFormat" width="150">
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditCreate(scope.row)">修改</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini"
              @click="deleteCreate(scope.row.ReviewCriteriaID)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination>

      <!-- 添加 -->
      <el-dialog title="添加评分标准" :visible.sync="addDialogVisible" width="30%" @close="addresetFields">
        <!-- 快捷选择区域（新增） -->
        <div class="quick-select-area" style="margin-bottom: 20px;">
          <div style="margin-bottom: 10px; font-weight: bold; color: #666;font-size: 12px;">
            <i class="el-icon-s-claim"></i> 快捷选择标准（点击自动填充）
          </div>
          <el-checkbox-group v-model="selectedTemplates" @change="handleTemplateChange">
            <el-checkbox v-for="item in standardTemplates" :key="item.id" :label="item.id" size="small"
              style="margin-right: 10px; margin-bottom: 10px;">
              {{ item.label }}({{ item.score }}分)
            </el-checkbox>
          </el-checkbox-group>
          <el-button type="text" size="small" @click="clearTemplateSelection" style="margin-top: 5px;">
            <i class="el-icon-refresh-left"></i> 清空选择
          </el-button>
        </div>
        <el-form :model="addForm" :rules="addRules" ref="addFormRef" label-width="100px">
          <el-form-item label="赛事名称" prop="MatchID">
            <el-select v-model="addForm.MatchID" placeholder="请选择" @change="selectGettrack(addForm.MatchID, 1)"
              style="width: 360px !important">
              <el-option v-for="item in matchNameoptions1" :key="item.MatchID" :label="item.MatchName"
                :value="item.MatchID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赛道名称" prop="TrackID">
            <el-select v-model="addForm.TrackID" style="width: 360px !important" placeholder="请选择">
              <el-option v-for="item in trackNameoptions1" :key="item.TrackID" :label="item.TrackName"
                :value="item.TrackID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标准名称" prop="StandardName">
            <el-input v-model="addForm.StandardName"></el-input>
          </el-form-item>
          <el-form-item label="标准内容" prop="StandardContent">
            <el-input type="textarea" v-model="addForm.StandardContent"></el-input>
          </el-form-item>
          <el-form-item label="分数" prop="Score">
            <el-input v-model="addForm.Score"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addCreate()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改 -->
      <el-dialog title="修改评分标准" :visible.sync="editDialogVisible" width="30%" @close="editresetFields">
        <el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="100px">
          <el-form-item label="赛事名称" prop="MatchID">
            <el-select v-model="editForm.MatchID" placeholder="请选择" @change="selectGettrack(editForm.MatchID, 2)"
              style="width: 360px !important">
              <el-option v-for="item in matchNameoptions2" :key="item.MatchID" :label="item.MatchName"
                :value="item.MatchID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赛道名称" prop="TrackID">
            <el-select v-model="editForm.TrackID" placeholder="请选择赛道" clearable style="width: 360px !important">
              <el-option v-for="item in trackNameoptions2" :key="item.TrackID" :label="item.TrackName"
                :value="item.TrackID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标准名称" prop="StandardName">
            <el-input v-model="editForm.StandardName"></el-input>
          </el-form-item>
          <el-form-item label="标准内容" prop="StandardContent">
            <el-input type="textarea" v-model="editForm.StandardContent"></el-input>
          </el-form-item>
          <el-form-item label="分数" prop="Score">
            <el-input v-model="editForm.Score"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="editCreate()">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    var isNumber = (rule, value, cb) => {
      // 不能使用中文正则
      const regNumber = /^[0-9]*$/
      if (!regNumber.test(value)) {
        cb(new Error('只能填写数字'))
      } else {
        cb()
      }
    }
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        // 赛项名称
        MatchName: '',
        // 赛道名称
        TrackName: '',
        // 当前页码
        pagenum: 1,
        // 每页显示条数
        pagesize: 10
      },
      pagedata: [],
      total: 0,
      // 添加弹框显示状态
      addDialogVisible: false,
      // 修改弹框显示状态
      editDialogVisible: false,
      // 评审须知弹框显示状态
      noticeDialogVisible: false,
      // 弹窗默认标题
      dialogTitle: '',
      // 添加表单
      addForm: {
        MatchName: '',
        TrackID: '',
        StandardName: '',
        StandardContent: '',
        Score: '',
        SortIndex: ''
      },
      // 修改表单
      editForm: {},
      // 添加表单验证
      addRules: {
        MatchID: [
          {
            required: true,
            message: '请输入选择赛事名称',
            trigger: 'change'
          }
        ],
        TrackID: [
          {
            required: true,
            message: '请输入选择赛道名称',
            trigger: 'change'
          }
        ],
        StandardName: [
          {
            required: true,
            message: '请输入标准名称',
            trigger: 'blur'
          }
        ],
        StandardContent: [
          {
            required: true,
            message: '请输入标准内容',
            trigger: 'blur'
          }
        ],
        Score: [
          {
            required: true,
            message: '请输入分数',
            trigger: 'blur'
          },
          {
            validator: isNumber,
            trigger: 'blur'
          }
          // { max: 4, message: '最多三位数', trigger: 'blur' }
        ]
      },
      // 修改表单验证
      editRules: {
        MatchID: [
          {
            required: true,
            message: '请输入选择赛道名称',
            trigger: 'change'
          }
        ],
        TrackID: [
          {
            required: true,
            message: '请输入选择赛道名称',
            trigger: 'change'
          }
        ],
        StandardName: [
          {
            required: true,
            message: '请输入标准名称',
            trigger: 'blur'
          }
        ],
        StandardContent: [
          {
            required: true,
            message: '请输入标准内容',
            trigger: 'blur'
          }
        ],
        Score: [
          {
            required: true,
            message: '请输入分数',
            trigger: 'blur'
          },
          {
            validator: isNumber,
            trigger: 'blur'
          }
          // { max: 2, message: '最多二位数', trigger: 'blur' }
        ]
      },
      // 搜索赛事名称下拉选项
      matchNameoptions: [],
      // 搜索赛道下拉选项
      trackNameoptions: [],
      // 搜索下拉选择赛返回当前选中对象
      matchoObj: {},
      // 添加赛事名称下拉选项
      matchNameoptions1: [],
      // 添加赛道下拉选项
      trackNameoptions1: [],
      // 添加下拉选择赛返回当前选中对象
      matchoObj1: {},
      // 修改赛事名称下拉选项
      matchNameoptions2: [],
      // 修改赛道下拉选项
      trackNameoptions2: [],
      // 修改下拉选择赛返回当前选中对象
      matchoObj2: {},
      // 预定义的评分标准模板
      standardTemplates: [
        {
          id: 1,
          label: '1、作品难度',
          standardName: '1、作品难度',
          standardContent: '（1）考虑作品的工作量大小 （2）考虑作品的工作难易程度是否超出合理范围',
          score: 10
        },
        {
          id: 2,
          label: '2、创新性',
          standardName: '2、创新性',
          standardContent: '（1）作品构思是否新颖 （2）对所研究的作品是否有新见解 （3）与现有研究相比作品是否有改进',
          score: 30
        },
        {
          id: 3,
          label: '3、专业知识综合运用',
          standardName: '3、专业知识综合运用',
          standardContent: '（1）作品设计是否合理 （2）作品与所学知识领域是否有较强的相关性 （3）作品是否存在学术价值',
          score: 20
        },
        {
          id: 4,
          label: '4、实用价值',
          standardName: '4、实用价值',
          standardContent: '（1）作品的实际运用价值 （2）作品的现实社会意义',
          score: 30
        },
        {
          id: 5,
          label: '5、综合评价',
          standardName: '5、综合评价',
          standardContent: '作品的综合水平如何',
          score: 10
        }
      ],

      // 记录已选择的模板ID（用于控制复选框状态）
      selectedTemplates: []
    }
  },
  created() {
    //   默认获取列表
    this.getStandardList(1)
    // 默认获取赛事
    this.getAllMatch()
  },
  methods: {
    //   获取列表
    async getStandardList(newPage) {
      this.queryInfo.pagenum = newPage
      const { data: res } = await this.$http.get(
        '/api/ReviewCriteria/GetAllReviewCriteria',
        { params: this.queryInfo }
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.pagedata = res.Data.allReviewCriteria
      this.total = res.Data.total
    },
    //   下拉获取所有赛事
    async getAllMatch() {
      const { data: res } = await this.$http.get('/api/Match/GetMatchs')
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.matchNameoptions = res.Data.matchs
      this.matchNameoptions1 = res.Data.matchs
      this.matchNameoptions2 = res.Data.matchs
    },
    // 下拉赛项获取对应赛道
    // selectType 0搜索 1 添加 2修改
    async selectGettrack(id, selectType) {
      const { data: res } = await this.$http.get('/api/Track/GetTracks', {
        params: { MatchID: id + 0 }
      })
      if (res.StatusCode !== 1) return console.log(res.Msg)
      if (selectType === 0) {
        this.$set(this.queryInfo, 'TrackID', null)
        this.trackNameoptions = res.Data.tracks
      } else if (selectType === 1) {
        this.$set(this.addForm, 'TrackID', null)
        this.trackNameoptions1 = res.Data.tracks
      } else if (selectType === 2) {
        this.$set(this.editForm, 'TrackID', null)
        this.trackNameoptions2 = res.Data.tracks
      }
    },
    // 修改加载赛道
    async editSelectGettrack(id) {
      const { data: res } = await this.$http.get('/api/Track/GetTracks', {
        params: { MatchID: id + 0 }
      })
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.trackNameoptions2 = res.Data.tracks
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getStandardList(1)
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage
      this.getStandardList(newPage)
    },
    // 关闭弹窗重置表单验证
    addresetFields() {
      this.$refs.addFormRef.resetFields()
      this.selectedTemplates = [] // 清空模板选择
    },
    // 关闭弹窗重置表单验证
    editresetFields() {
      this.$refs.editFormRef.resetFields()
    },
    // 显示创建赛事弹窗
    showAddCreate() {
      // 打开弹窗
      this.addDialogVisible = true
    },
    // 显示修改赛事弹窗
    showEditCreate(row) {
      this.editForm = JSON.parse(JSON.stringify(row))
      this.editDialogVisible = true
      this.editSelectGettrack(this.editForm.MatchID)
    },
    // 添加
    addCreate() {
      this.$refs.addFormRef.validate(async (valid) => {
        // 验证不通过跳出
        if (!valid) return false
        // 发起添加请求
        const { data: res } = await this.$http.post(
          '/api/ReviewCriteria/EditReviewCriteria',
          this.addForm
        )
        // 判断状态码
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        // 成功提示
        this.$message.success(res.Msg)
        // 关闭弹窗
        this.addDialogVisible = false
        // 刷新列表
        this.getStandardList(1)
      })
    },
    // 修改
    editCreate(id) {
      this.$refs.editFormRef.validate(async (valid) => {
        // 验证不通过跳出
        if (!valid) return false
        // 发起添加请求
        const { data: res } = await this.$http.post(
          '/api/ReviewCriteria/EditReviewCriteria',
          this.editForm
        )
        // 判断状态码
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        // 成功提示
        this.$message.success(res.Msg)
        // 关闭弹窗
        this.editDialogVisible = false
        // 刷新列表
        this.getStandardList(this.queryInfo.pagenum)
      })
    },
    // 删除
    async deleteCreate(id) {
      // 提示是否确认删除
      console.log(id)
      const res = await this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => {
        return err
      })
      if (res !== 'confirm') return this.$message.info('已取消删除')
      const { data: resdel } = await this.$http.post(
        '/api/ReviewCriteria/DeleteReviewCriterias?reviewCriteriaIds=' + id
      )
      if (resdel.StatusCode !== 1) return this.$message.error('删除失败')
      this.$message.success('删除成功')
      // 刷新列表
      this.getStandardList(this.queryInfo.pagenum)
    },
    async setSortIndex(row) {
      const { data: res } = await this.$http.post(
        '/api/ReviewCriteria/UpdateSortIndex',
        row
      )
      if (res.StatusCode !== 1) return this.$message.error(res.Msg)
      this.$message.success(res.Msg)
      // 刷新列表
      this.getStandardList(this.queryInfo.pagenum)
      console.log(res)
    },
    // 时间格式化
    dataFormat: function (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    // 处理模板选择变化（单选模式：选一个填一个）
    handleTemplateChange(selectedIds) {
      // 获取最后选择的那个（最新点击的）
      const lastSelectedId = selectedIds[selectedIds.length - 1]

      if (lastSelectedId) {
        const template = this.standardTemplates.find(t => t.id === lastSelectedId)
        if (template) {
          // 自动填充到表单
          this.addForm.StandardName = template.standardName
          this.addForm.StandardContent = template.standardContent
          this.addForm.Score = template.score

          // 提示用户
          this.$message.success(`已自动填充：${template.label}`)
        }
      }

      // 重置为单选状态（保留最后一个），或根据需求改为多选批量添加
      if (selectedIds.length > 1) {
        this.selectedTemplates = [lastSelectedId]
      }
    },

    // 清空选择
    clearTemplateSelection() {
      this.selectedTemplates = []
      // 可选：是否同时清空表单
      this.addForm.StandardName = ''
      this.addForm.StandardContent = ''
      this.addForm.Score = ''
    }
  }
}
</script>
<style lang="less" scoped>
.total_score {
  color: #999;
  padding: 9px 0;
}

.el-table .el-input__inner {
  padding: 5px !important;
}

.quick-select-area {
  /deep/ .el-checkbox__label {
    font-size: 12px !important;
  }
}
</style>
